<template>
  <div id="fee-chart"></div>
</template>

<script>
  import echarts from 'echarts'

  export default {
    props: {
      bills: {
        default: () => [],
        type: Array
      },
    },
    data() {
      return {
        option: {
          color: ['#8ADBE6', '#8AADE6', '#E68ABC'],
          legend: {
            type: 'plain',
            right: 80,
            top: 20,
            textStyle: {
              color: '#E2E2E2'
            }
          },
          tooltip: {
            show: true,
            trigger: 'item',
            formatter: '{a}:{c0}天'
          },
          grid: {
            left: '5%',
            right: 30,

          },
          xAxis: {
            name: '月',
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#E2E2E2'
              }
            },
            axisLabel: {
              color: '#e1e1e1'
            }
          },
          yAxis: [
            {
              name: '设备数',
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#BAC3CE'
                }
              },
              axisLabel: {
                color: '#e1e1e1'
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#6c6c6c',
                  type: 'dashed'
                }
              }
            }
          ],
          series: {
            name: '计费数',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: []
          },
        },
        chart: null,
      }
    },
    methods: {
      _initCharts(bills) {

        this.chart = echarts.init(document.getElementById('fee-chart'))
        this.chart.setOption(this.option)
      },
      setData(dataLen, unit, type, data) {
        this.option.xAxis.name = unit
        this.option.xAxis.data = []
        this.option.series.data = []
        for (let i = 0; i < dataLen; i++) {
          this.option.xAxis.data.push((i + 1) + '')
          this.option.series.data.push(0)
        }
        if (type === `year`) {
          for(let i =0; i< data.length; i++){
            let d = data[i]
            this.option.series.data[d.month -1] = d.devices
          }
        } else {
          for(let i =0; i< data.length; i++){
            let d = data[i]
            this.option.series.data[d.day -1] = d.devices
          }
        }
        this.chart.setOption(this.option)
      }
    },
    watch: {
      bills(bills) {
        this._initCharts(bills)
      }
    },
    mounted() {
      this._initCharts([])
    }
  }
</script>

